// Todo: Move over tags from https://github.legalzoom.com/engineering/my-lz/blob/develop/apps/site-external-my-account-src/src/app/shared/constants/tracking-amplitude-event-label.enum.ts
export const AmplitudeLabels = {
  // Tax
  Tax_ViewConnectTaxInfoScreen: 'view connect tax info screen',
  Tax_ViewLegalAgreementScreen: 'view legal agreement screen',
  Tax_ExpandTaxLegalAgreement: 'expand tax legal agreement',
  Tax_AcceptTaxLegalAgreement: 'accept tax legal agreement',
  Tax_DismissTaxLegalAgreement: 'dismiss tax legal agreement',
  Tax_GoBackConnectTaxInfoScreen: 'go back connect tax info screen',
  Tax_ClickTaxInfoCTA: 'click tax info cta',
  Tax_ClickEmailAnExpertCTA: 'click email an expert cta',
  Tax_ClickGetStarted: 'click get started',
  Tax_ClickLaunchTaxQuestionnaire: 'click launch tax questionnaire',
  Tax_ClickMarkAsComplete: 'click mark as complete',
  Tax_ClickScheduleCall: 'click tax schedule call',
  Tax_ClickTaxHelpGuide: 'click tax help guide',
  Tax_LaunchTaxUpgrade: 'launch tax upgrade',
  Tax_ViewProgressTracker: 'view progress tracker',
  Tax_ViewTaxDocument: 'view tax document',
  Tax_UploadTaxDocument: 'upload tax document',
  Tax_DocumentUploadError: 'document upload error',

  // Engagement
  Engagement_ViewInterstitialOffer: 'view interstitial offer',
  Engagement_AcceptInterstitialOffer: 'accept interstitial offer',
  Engagement_DismissInterstitialOffer: 'dismiss interstitial offer',
  Engagement_DeclineInterstitialOffer: 'decline interstitial offer',
  Engagement_LaunchScheduleConsultation: 'launch schedule consultation',

  // Header
  Header_BrowseProducts: 'browse products',
  Header_OpenAccountSettings: 'open account settings',
  Header_SignOut: 'sign out',
  Header_LegacyMAOverview: 'open legacy my account overview',
  Header_LegacyMAOpenOrders: 'open legacy my account open orders',
  Navigation_OpenResources: 'open resources',
  Navigation_OpenContactUs: 'open contact us',
  Navigation_OpenOrders: 'open orders',

  // Workspace Switcher
  Workspace_SwitchWorkspace: 'switch workspace',
  Workspace_CreateWorkspace: 'click create a new business workspace',
  Workspace_SelectWorkspace: 'click workspace selection',
  Workspace_SelectDropdown: 'click workspace dropdown',

  // Business Toolkit
  BusinessToolkit_LaunchService: 'launch service',

  // Login
  Auth_ViewSignIn: 'view sign in',
  Auth_ViewSignUp: 'view sign up',
  Auth_ViewForgotPassword: 'view forgot password',
  Auth_ViewForgotPasswordConfirm: 'view forgot password confirm',
  Auth_SignIn: 'click sign in',
  Auth_SignUp: 'click sign up',
  Auth_CreateAnAccount: 'click create an account',
  Auth_ForgotPasswordConfirm: 'click forgot password confirm',
  Auth_ForgotPassword: 'click forgot password',
  Auth_ReturnToForgetPassword: 'click try again to return to forgot password',
  Auth_SendPasswordReset: 'click send password reset',
  Auth_ViewChangePassword: 'view change password',
  Auth_ViewChangePasswordSuccess: 'view change password success',

  // Mfa
  Mfa_ViewAddEnrollment: 'view add enrollment',
  Mfa_ViewEnterCode: 'view enter code',
  Mfa_ClickResend: 'click resend',
  Mfa_ViewIdentityVerification: 'view verify identity',
  Mfa_ViewIdentityVerificationResults: 'view identity verification results',
  Mfa_ViewGetHelp: 'view identity verification get help',
  Mfa_ViewAgentWillReachOut: 'view identity verification agent will reach out',

  // Virtual Mail
  VirtualMail_SelectPlan: 'select virtual mail plan',
  VirtualMail_SelectAddress: 'select virtual mail address',
  VirtualMail_CheckoutPay: 'click pay in virtual mail checkout',
  VirtualMail_LaunchNotaryFlow: 'launch notary flow',
  VirtualMail_Launch1583Form: 'launch 1583 form preview',
  VirtualMail_CopyAddress: 'copy address to clipboard',
  VirtualMail_ClickSettings: 'click virtual mail settings',
  VirtualMail_RequestScan: 'request scan',
  VirtualMail_ClickManage: 'click manage',
  VirtualMail_ClickViewAllMail: 'click view all mail',
  VirtualMail_AccountReactivationPay:
    'click update and pay button in virtual mail account reactivation',
  VirtualMail_AccountReactivationClickStatement:
    'click view statement in virtual mail account reactivation',

  // Business Email - Google Workspace
  GoogleWorkspace_ViewSeatCount: 'view seat count',
  GoogleWorkspace_AdjustSeatCount: 'adjust seat count',
  GoogleWorkspace_ViewOrderSummary: 'view order summary',
  GoogleWorkspace_ConfirmWorkspaceSubscription:
    'confirm workspace subscription',
  GoogleWorkspace_LaunchLogInToGoogle: 'launch log in to google',
  GoogleWorkspace_ViewDomainPurchase: 'view domain purchase',
  // Chat
  Chat_ViewChat: 'view chat',
  Chat_OpenChat: 'open chat',

  // Orders
  Orders_LaunchDeleteOrder: 'launch delete order',
  Orders_DeleteOrder: 'delete order',
  Orders_LaunchResumeOrder: 'launch resume order',
  Orders_LaunchCompleteOrder: 'launch complete order',
  Orders_LaunchFixOrder: 'launch fix order',
  Orders_ViewOrder: 'view order',
  Orders_LaunchActivateOrder: 'launch activate order',
  Orders_ActivateOrder: 'activate order',
  Orders_SwitchViewOrders: 'switch view orders',
  Orders_ReviseOrder: 'revise order',

  // Guidance
  Guidance_ViewTask: 'view task',
  Guidance_LaunchTask: 'launch task',
  Guidance_CompleteTask: 'complete task',
  Guidance_UndoCompleteTask: 'undo complete task',
  Guidance_UndoVerifyTask: 'undo verify task',
  Guidance_ShowMoreTasks: 'show more tasks',
  Guidance_ShowLessTasks: 'show less tasks',
  Guidance_ViewTasksZeroState: 'view tasks zero state',
  Guidance_ViewTasksList: 'view tasks list',
  Guidance_LaunchTermsAndPrivacy: 'launch terms and privacy',
  Guidance_LaunchPartnershipWebsite: 'launch partnership website',
  Guidance_ViewTasksModal: 'view tasks modal',
  Guidance_LoadTasks: 'load tasks',
  Guidance_LaunchTaskGroup: 'launch task group',

  // Advisor Card
  GoToExpertPage: 'goto expert page',
  ViewMyAdvisors: 'view my advisors',

  // Tax Interest
  TaxProductInterest: 'tax product interest',

  // Legal
  BAP_ZeroStateLearnMore: 'bap zero state learn more',
  ConfirmAAFCall: 'confirm AAF call',
  ConfirmCall: 'Confirm call',

  // AAF Drawer
  Consultation_StartScheduling: 'start scheduling',
  Consultation_ConfirmConsult: 'confirm consult',
  Consultation_ViewAdvisorProfile: 'view advisor profile',
  Consultation_Cancel: 'cancel consult',
  Consultation_Reschedule: 'reschedule consult',
  Consultation_Schedule: 'schedule consult',

  // BAP purchase
  Subscription_Interest: 'select subscription',
  View_Order_Summary: 'view order summary',
  Confirm_Subscription: 'confirm subscription',
  View_Purchase_Confirmation: 'view purchase confirmation',
  Revenue: 'Revenue',
  View_Payment_Declined: 'view payment declined',
  Launch_Update_Payment: 'launch update payment',

  // Legal
  ViewConfirmCall: 'view confirm call page',
  AAFConsultConfirmed: 'AAF consult confirmed',
  BAPTakeoverSubmit: 'BAP takeover review and submit',
  SelectYourPlan: 'select your plan',
  CancelConsult: 'cancel consult',

  //Lead
  LeadGen: 'Lead Gen',

  // Negroni
  Interaction: 'interaction',
  ViewSurface: 'view surface',

  // Doc center
  ViewDocuments: 'view documents',
  Search: 'Search',

  // IQ Flow
  ClickToggleSection: 'click toggle section',
  ClickMoreInfo: 'click more info',
};

export type AmplitudeLabels =
  (typeof AmplitudeLabels)[keyof typeof AmplitudeLabels];
